import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';

import './lib/i18n/i18n';
import '@repo/ui/styles.css';

import { RouterProvider } from 'react-router-dom';
import './lib/axios/axios-global';
import router from '@/core/global-router';
import { Provider } from 'react-redux';
import store from '@/core/global-store';
import LangSettings from '@/lib/i18n/LangSettings';
import { Toaster, ErrorBoundary } from '@repo/ui';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <ErrorBoundary>
        <Provider store={store}>
            <LangSettings>
                <Suspense
                    fallback={
                        <div className="flex min-h-screen items-center justify-center font-cairo">
                            جاري التحميل...
                        </div>
                    }
                >
                    <RouterProvider router={router} />
                    <Toaster />
                </Suspense>
            </LangSettings>
        </Provider>
    </ErrorBoundary>,
);
